module.exports = __webpack_public_path__ + "assets/img/goods_adv1.5e7af426.jpg";